module.exports = __webpack_public_path__ + "img/skattedag_6.be25e88f.png";